@if (isInToolbar && !hasChildren) {
  <button [class.menu-item-active]="isHighlighted" id="menuId-{{menu.id}}"
    class="menu-button" (click)="clickButton(menu.id)">
    <div class="submenu-name">
      <div>{{menu.name}}</div>@if (menu.count !== undefined) {
      <div class="numberCircle">{{menu.count}}</div>
    }
  </div>
</button>
}

@if (isInToolbar && hasChildren) {
  <button [class.menu-item-active]="isHighlighted" class="menu-button"
    [matMenuTriggerFor]="childMenu" id="menuId-{{menu.id}}">
    <div class="submenu-name">
      <div>{{menu.name}}</div>@if (menu.count !== undefined) {
      <div class="numberCircle">{{menu.count}}</div>
    }
  </div>
  <mat-icon class="menu-icon" [svgIcon]="icons.EXPAND_MORE"></mat-icon>
</button>
}

<mat-menu #childMenu xPosition="after">
  @for (submenu of menu.subMenuItems; track submenu.id) {
    @if (submenu.subMenuItems === undefined || submenu.subMenuItems.length === 0) {
      <button class="mat-menu-item" id="menuId-{{submenu.id}}" (click)="clickButton(submenu.id)" mat-menu-item
        >
        <div class="submenu-name">
          <div>{{submenu.name}}</div>@if (submenu.count !== undefined) {
          <div class="numberCircle">{{submenu.count}}</div>
        }
      </div>
    </button>
  } @else {
    <button class="mat-menu-item" id="menuId-{{submenu.id}}" mat-menu-item [matMenuTriggerFor]="menu.childMenu">
      <div class="submenu-name">
        <div>{{submenu.name}}</div>@if (submenu.count !== undefined) {
        <div class="numberCircle">{{submenu.count}}</div>
      }
    </div>
  </button>
  <fss-portal-menu #menu [menu]="submenu">
  </fss-portal-menu>
}
}
</mat-menu>